import { withSchema } from '@websolutespa/bom-core';
import { Select as SelectBase } from './select';
import { SelectLabel } from './select-label';
import { SelectOption } from './select-option';
import { SelectOptionCheck } from './select-option-check';
import { SelectPopover } from './select-popover';
import { SelectSelect } from './select-select';

export const Select = withSchema(
  SelectBase,
  {
    Label: SelectLabel,
    Select: SelectSelect,
    Popover: SelectPopover,
    Option: SelectOption,
    OptionCheck: SelectOptionCheck,
  });

export type { SelectProps } from './select';
export type { SelectLabelProps } from './select-label';
export type { SelectOptionProps } from './select-option';
export type { SelectOptionCheckProps } from './select-option-check';
export type { SelectPopoverProps } from './select-popover';
export type { SelectSelectProps } from './select-select';

export * from './select.variants';

